import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactModal from 'react-modal';
import Message from '../Common/Message/Message';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './ReprintOrder.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ReprintOrder extends Component {
	constructor(props) {
	    super(props);
	    this.state = {
	      	email: "",
	      	validation: {
	      		email: {
	      			valid: null,
                    msg: ''
	      		}
            },
            isReadyToSubmit: false,
            message: {
                title: '',
                content: '',
                type: ''
            }
	    };
    }
    
    toggleReprintOrder = () => {
        this.props.toggleReprintOrder();
    }

	toggle = () => {
        this.toggleReprintOrder(false);
        this.reset();
    }
    
    reset = () => {
        this.setState(this.baseState);
    }

	handleChange = (e) => {
        let value = e.target.value;
        const name = e.target.name;
        let email = {...this.state.email};
        email = value;
        this.setState({ email });
        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, name, validationRegEx);
        }
        this.validateAllRequiredFields();
    }

    validate = (value, name, validationRegEx) => {
        const validation = { ...this.state.validation };
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value)) {
            value === '' ? validation[name]['msg'] = strings.errorRequired : validation[name]['msg'] = strings.errorInvalid;
            isValid = false;
        }
        validation[name]['valid'] = isValid;
        this.setState({ validation });
    }

    validateRequiredField = (e) => {
        if (e.target.value === '' && e.target.attributes.getNamedItem('required')) {
            const name = e.target.name;
            const validation = { ...this.state.validation };
            validation[name]['msg'] = strings.errorRequired;
            validation[name]['valid'] = false;
            this.setState({ validation });
        }
    }

    validateAllRequiredFields = () => {
        const validation = { ...this.state.validation };
        let isReadyToSubmit = { ...this.state.isReadyToSubmit };
        let i = Object.keys(validation).length;
        for (let field in validation) {
            if (typeof validation[field]['valid'] !== "undefined") {
                if (validation[field]['valid']) {
                    i--;
                }
            }
        }
        isReadyToSubmit = (i === 0);
        this.setState({ isReadyToSubmit });
    }

    afterAction = (title, description, type) => {
        this.setMessage(title,description,type);
        setTimeout(() => {
            this.setMessage('', '', '');
        }, 3000);
        this.setState({ 
            email:'',
            isReadyToSubmit:false
        });
    }

    submit = () => {
        const email = this.state.email;
        console.log(email);

        const doReprintOrders = async (email) => {
            try {
                const response = await reprint_orders(email);
                console.log('Response: ', response);

                if(response.data.success){
                    this.afterAction(window.general_strings.msg.yay,strings.msg.success,'success');
                } else {
                    this.afterAction(window.general_strings.msg.oops,response.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
                this.afterAction(window.general_strings.msg.oops,error,'error');
            }
        }

        async function reprint_orders(email) {
            return await ApiRequest(`/tickets/reprint`, {
                method: 'POST',
                data: {
                    email: email
                }
            });
        }

        doReprintOrders(email);
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

	componentWillMount() {
        this.baseState = JSON.parse(JSON.stringify(this.state));
        this.setState({ modal: this.props.isReprintOrderOpen });
    }
    
    componentWillReceiveProps() {
        this.setState({
			modal: this.props.isReprintOrderOpen
		});
	}

	render() {
	  	return (
			<div>
                <ReactModal 
                    className="showtix-event__modal"
                    isOpen={this.props.isReprintOrderOpen}
                    role={
                        "dialog"
                    }
                >
                    <button className="showtix-modal__close" onClick={() => this.toggle} aria-label="Close the modal">&times;</button>
                    <h4 className="modal-title text-center">{strings.title}</h4>
                    <div aria-live="polite">
                        <Message 
                            message={this.state.message}
                        />
                    </div>
		            	<p>{strings.description}</p>
		            	<div className={"showtix-form__group pb-0 " + (this.state.validation.email.valid === false && this.state.validation.email !== '' ? 'showtix-form__error' : '')}>
                        <label className="showtix-label" htmlFor="reprint_email">{strings.email}*</label>
                        <div className="showtix-form__input">
                            <input
                                type="text"
                                className="showtix-input"
                                placeholder={strings.email}
                                id="reprint_email"
                                name="email"
                                value={this.state.email}
                                validation="(^([\w-\.]+@([\w-]+\.)+[\w-]{2,})?$)"
                                onChange={this.handleChange}
                                onBlur={this.validateRequiredField}
                                aria-invalid={!this.state.validation.email.valid}
                                required 
                            />
                        </div>
                        <div aria-live="polite">
                            {!this.state.validation.email.valid &&
                                <div className="showtix-note error">
                                    {this.state.validation.email.msg}
                                </div>
                            }
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button 
		            		type="submit" 
		            		className="showtix-button showtix-background__primary-3"
                            disabled={!this.state.isReadyToSubmit}
                            onClick={this.submit}
		            		>{strings.send}</button>
                    </div>
                </ReactModal>
			</div>
	  	);
	}
}

ReprintOrder.propTypes = {
    isReprintOrderOpen: PropTypes.bool,
    toggleReprintOrder: PropTypes.func
}

export default ReprintOrder;


// WEBPACK FOOTER //
// ./src/components/ReprintOrder/ReprintOrder.js